module.exports = __webpack_public_path__ + "static/media/healthcare.1b8b2020.png";